import React from 'react';
import PropTypes from 'prop-types';
import Headline from '@components/atoms/headline/headline';
import { ArrowRight } from '@components/icons/arrow/arrow';
import Link from 'next/link';
import EducationNumber from '@components/atoms/education/number/educationNumber';
import EducationTime from '@components/atoms/education/time/educationTime';
import MixedCopy from '@components/molecules/mixed-copy/mixedCopy';
import StyledEducationTabletCard from './educationTabletCard.style';

function stripHtmlTags(text) {
  if (!text) return '';
  return text.replace(/(<([^>]+)>)/gi, '');
}

const EducationTabletCard = ({
  headline,
  copy,
  educationTopics,
  educationType,
  duration,
  slug,
  number
}) => {
  return (
    <StyledEducationTabletCard>
      <div className="tablet-card">
        <div className="tablet-card__tag-line hidden--desktop">
          {duration && <EducationTime value={duration} />}
        </div>
        <div className="tablet-card__content">
          <div className="tablet-card__headline">
            <div className="tablet-card__number">
              {number && (
                <EducationNumber
                  className="card-number__square"
                  contentType={educationType}
                  category={educationTopics}
                  number={number}
                />
              )}
            </div>
            <div className="tablet-card__headline-content">
              <div className="tablet-card__tag-line hidden--mobile">
                {duration && <EducationTime value={duration} />}
              </div>
              {headline && (
                <Headline className="tablet-card__headline-text" tag="span">
                  {headline}
                </Headline>
              )}
            </div>
          </div>
          <MixedCopy
            className="tablet-card__copy"
            fullWidth
            html={
              stripHtmlTags(copy).length > 340
                ? `${stripHtmlTags(copy).substring(0, 340)}...`
                : stripHtmlTags(copy)
            }
          />
        </div>
        {slug && (
          <div className="tablet-card__link">
            <Link href={`${slug}`} shallow>
              <span className="tablet-card__link-inner">
                <Headline tag="span" className="tablet-card__link-title">
                  Öffnen
                </Headline>
                <ArrowRight />
                <span className="tablet-card__stretched-link" />
              </span>
            </Link>
          </div>
        )}
      </div>
    </StyledEducationTabletCard>
  );
};

EducationTabletCard.propTypes = {
  duration: PropTypes.number.isRequired,
  headline: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  copy: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  educationTopics: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired,
  educationType: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    })
  ).isRequired
};

export default EducationTabletCard;
